/** The module every package has (stores, staff, offerings); it can't be turned off. */
export const CORE_MODULE = 'core'

/**
 * Whether a package module is on for the active company. `modules` is /api/me's list:
 * null or absent (an older core, or no company) means every module is on, so nothing
 * disappears before core ships packages. Core is always on.
 */
export function moduleEnabled(modules: readonly string[] | null | undefined, key: string): boolean {
  if (modules == null) return true
  if (key === CORE_MODULE) return true
  return modules.includes(key)
}

/**
 * Whether at least one of several modules is on: a menu that serves more than one
 * module (Rewards: `promo_codes` or `loyalty`). Same null rule as {@link moduleEnabled}.
 */
export function anyModuleEnabled(modules: readonly string[] | null | undefined, keys: readonly string[]): boolean {
  return keys.some((key) => moduleEnabled(modules, key))
}
